exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1Kt07qhPiR3-KCvn29PAyZ{color:var(--themePrimary)}", ""]);
// Exports
exports.locals = {
	"unscheduleText": "_1Kt07qhPiR3-KCvn29PAyZ"
};